module.exports = __webpack_public_path__ + "static/img/brand_story_main.91d658c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandStory/brand_story_main.png
// module id = wEoI
// module chunks = 0